import { ItemImage } from '@/api';

export function getPoster(images: ItemImage[]) {
    const poster = images.find((image) => image.is_poster);
    if (poster) {
        return poster;
    }
    return images.find((image) => image.type === ItemImage.TypeEnum.Image);
}
